// Shared option lists for the standard user profile fields, used by
// Signup, Account settings, and the profile verification modal.

export const TITLE_OPTIONS = ['Mr.', 'Mrs.', 'Ms.', 'Mx.', 'Dr.'];

export const GENDER_OPTIONS = ['Female', 'Male', 'Non-binary', 'Prefer to self-describe', 'Prefer not to say'];
